import {
  StorefrontAbTestDetailSchema,
  StorefrontAbTestSchema,
} from "@redotech/redo-coverage-common/storefront-ab-test";
import { StorefrontTreatmentSettingsSchema } from "@redotech/redo-coverage-common/storefront-treatment-settings";
import {
  storefrontAbTestIdFormat,
  storefrontTreatmentIdFormat,
} from "@redotech/redo-coverage-id";
import * as z from "zod";

const nameSchema = z.string().trim().min(1).max(200);

export const listStorefrontAbTests = {
  name: "listStorefrontAbTests" as const,
  input: z.object({}),
  output: z.object({ tests: z.array(StorefrontAbTestSchema) }),
};

export const createStorefrontAbTest = {
  name: "createStorefrontAbTest" as const,
  input: z.object({ name: nameSchema }),
  output: z.object({ test: StorefrontAbTestSchema }),
};

export const getStorefrontAbTest = {
  name: "getStorefrontAbTest" as const,
  input: z.object({ id: storefrontAbTestIdFormat.schema }),
  output: z.object({ detail: StorefrontAbTestDetailSchema }),
};

const treatmentFieldsSchema = z.object({
  name: nameSchema,
  weight: z.number().int().min(0).max(100),
  coverageEnabled: z.boolean(),
});

/**
 * Saves the test and its full arm list in display order. Arms left out are
 * deleted; arms without an id are created with their settings.
 */
export const updateStorefrontAbTest = {
  name: "updateStorefrontAbTest" as const,
  input: z.object({
    id: storefrontAbTestIdFormat.schema,
    name: nameSchema,
    treatments: z
      .array(
        z.union([
          treatmentFieldsSchema.extend({
            id: storefrontTreatmentIdFormat.schema,
          }),
          treatmentFieldsSchema.extend({
            id: z.null(),
            settings: StorefrontTreatmentSettingsSchema,
          }),
        ]),
      )
      .min(1),
  }),
  output: z.object({ detail: StorefrontAbTestDetailSchema }),
};

export const updateStorefrontTreatmentSettings = {
  name: "updateStorefrontTreatmentSettings" as const,
  input: z.object({
    id: storefrontTreatmentIdFormat.schema,
    settings: StorefrontTreatmentSettingsSchema,
  }),
  output: z.object({}),
};
